import React, { useState, useEffect, useRef } from 'react'
import Button from 'react-bootstrap/Button'
import { FaPlus } from 'react-icons/fa'
import { filesURL } from '../config/globals'
import AddMarkerModal from "../components/AddMarkerModal"

const ModelViewer2d = (props) => {
    const [modelImage, setModelImage] = useState()
    const [modelImageRect, setModelImageRect] = useState()
    const [isAddMarkModalShown, setIsAddMarkModalShown] = useState(false)
    const [isAddingMark, setIsAddingMark] = useState(false)
    const [activeMark, setActiveMark] = useState(null)
    
    const imageRef = useRef(null)

    useEffect(() => {
        window.addEventListener('resize', resizeModel)
        return () => {
            window.removeEventListener("resize", resizeModel);
        };
    }, [])

    const resizeModel = (e) => {
        setModelImageRect(imageRef.current.getBoundingClientRect())
    }

    const openAddMarkModal = () => setIsAddMarkModalShown(true)
    const closeAddMarkModal = () => {
        setIsAddMarkModalShown(false)
        setIsAddingMark(false)
        setActiveMark(null)
    }

    const openMark = (id) => {
        setActiveMark(props.record.markers.find(mark => mark.id === id))
        setIsAddMarkModalShown(true)
    }

    const onModelLoad = (event) => {
        setModelImage(event.target)
        setModelImageRect(event.target.getBoundingClientRect())
    }

    const handleClick = (event) => {
        if (!isAddingMark) {
            return
        }

        const bounds = event.target.getBoundingClientRect()
        const x = Math.round(event.pageX - bounds.left - window.scrollX)
        const y = Math.round(event.pageY - bounds.top - window.scrollY)

        const realWidth = event.target.naturalWidth;
        const realHeight = event.target.naturalHeight;
        
        const realX = Math.round(realWidth * x / bounds.width)
        const realY = Math.round(realHeight * y / bounds.height)

        setActiveMark({
            id: props.record.markers ? props.record.markers.length + 1 : 0,
            category: props.currentCategory,
            type: "goodCondition",
            title: "",
            description: "",
            point: { x: realX, y: realY }
        })

        openAddMarkModal()
    }

    const saveMarker = (form) => {
        closeAddMarkModal()

        if (form.createdAt) {
            props.onUpdateMarker(form)
            return
        }
        
        const mark = activeMark
        mark.title = form.title
        mark.description = form.description
        mark.type = form.type
        mark.category = form.category
        mark.image = form.image
        mark.createdAt = (new Date()).toISOString()

        props.onAddMarker(mark)
    }

    return (
        <>
            <div className="model-viewer-box">
                <div className="model-viewer-gui">
                    {props.category &&
                        <h3 className="mt-2">
                            {props.category.label}
                        </h3>
                    }
                    {props.allowNewMarkers &&
                        <Button
                            variant={isAddingMark ? "primary" : "outline-primary"}
                            className="toggleButton"
                            onClick={e => setIsAddingMark(!isAddingMark)}
                        >
                            <FaPlus /> Add Mark
                        </Button>
                    }
                </div>
                <div>
                    <img ref={imageRef} src={`${filesURL}/${props.modelFileName}`} width="100%" onClick={handleClick} onLoad={onModelLoad} />
                    {modelImage && modelImageRect && props.record.markers && props.record.markers.map(mark => (
                        <button
                            key={`hotspot-${mark.id}`}
                            className={`annotation-mark annotation-mark-${mark.type}`}
                            style={{
                                position: 'absolute',
                                left: (mark.point.x * modelImageRect.width / modelImage.naturalWidth) - 10,
                                top: (mark.point.y * modelImageRect.height / modelImage.naturalHeight) - 10
                            }}
                            onClick={e => {
                                e.preventDefault()
                                openMark(mark.id)
                            }}
                        >
                            {mark.id}
                        </button>
                    ))}
                </div>
            </div>
            <AddMarkerModal 
                isAddMarkModalShown={isAddMarkModalShown}
                activeMark={activeMark}
                onCloseAddMarkModal={closeAddMarkModal}
                onSaveMarker={saveMarker}
            />
        </>
    )
}

export default ModelViewer2d